/** Shared action catalogs (Storybook + prop validators). */

export const ACTION_CONFIG = {
  Award: {
    label: "Award Badge",
    backgroundColor: "#7f56d9",
  },
  "Give Badge": {
    label: "Give Badge",
    backgroundColor: "#000000",
  },
  "Upgrade Badge": {
    label: "Upgrade Badge",
    backgroundColor: "#000000",
  },
  Remove: {
    label: "Remove Badge",
    backgroundColor: "#b0b0b0",
  },
  "Inspect and Award": {
    label: "Inspect and Award",
    backgroundColor: "#7f56d9",
  },
};

export const ISSUE_BADGE_ACTIONS = Object.keys(ACTION_CONFIG);
